import { render, staticRenderFns } from "./SpiritAbilityOptions.vue?vue&type=template&id=1182c596&scoped=true"
import script from "./SpiritAbilityOptions.vue?vue&type=script&lang=js"
export * from "./SpiritAbilityOptions.vue?vue&type=script&lang=js"
import style0 from "./SpiritAbilityOptions.vue?vue&type=style&index=0&id=1182c596&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182c596",
  null
  
)

export default component.exports